export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '62bdad3f-cea5-4b8d-bd0b-b2fd5e2c8e27';
export const MODAL_CLOSE_SEC = 2.5;
